import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import type { SectionIconList } from "services/cms/models/sectionIconList";

const iconNameMap = {
    adaptive_cruise: "AdaptiveCruise32",
    aircon: "Aircon32",
    alloy_wheels: "AlloyWheels32",
    award_winning_friendly_service: "AwardWinningFriendlyService32",
    bluetooth: "Bluetooth32",
    car_play_android_audio: "CarPlayAndroidAudio32",
    clean_air_compliant: "CleanAirCompliant32",
    climate_control: "ClimateControl32",
    cloth_seats: "ClothSeats32",
    cruise_control: "CruiseControl32",
    dab_radio: "DABRadio32",
    digital_cockpit: "DigitalCockpit32",
    electric_seat_adjustment: "ElectricSeatAdjustment32",
    electric_seats: "ElectricSeats32",
    electric_sunroof: "ElectricSunroof32",
    electric_windows: "ElectricWindows32",
    folding_mirrors: "FoldingMirrors32",
    front_parking_sensor: "FrontParkingSensor32",
    fuel_type_diesel: "FuelTypeDiesel32",
    fuel_type_eco: "FuelTypeEco32",
    fuel_type_petrol: "FuelTypePetrol32",
    half_leather: "HalfLeather32",
    heated_seats: "HeatedSeats32",
    home_delivery: "HomeDelivery32",
    keyless_entry: "KeylessEntry32",
    lane_departure_warning: "LaneDepartureWarning32",
    lane_keep_assist: "LaneKeepAssist32",
    leather_interior: "LeatherInterior32",
    mileage: "Mileage32",
    money_back_guarantee: "MoneyBackGuarantee32",
    motor_point_warranty: "MotorPointWarranty32",
    nobody_beats_us: "NobodyBeatsUs32",
    paint_option: "PaintOption32",
    pan_roof: "PanRoof32",
    previous_owner: "PreviousOwner32",
    privacy_glass: "PrivacyGlass32",
    quality_standard: "QualityStandard32",
    rear_parking_camera: "RearParkingCamera32",
    rear_parking_sensor: "RearParkingSensor32",
    registration: "Registration32",
    reserve_online: "ReserveOnline32",
    sat_nav: "SatNav32",
    tailored_finance_options: "TailoredFinanceOptions32",
    traffic_light_recognition: "TrafficLightRecognition32",
    transmission: "Transmission32",
    ultra_low_emission_zone_compliant: "UltraLowEmissionZoneCompliant32",
    voice_control: "VoiceControl32",
} as const;

interface ResolvedIcon {
    icon: (typeof iconNameMap)[keyof typeof iconNameMap];
    label: string;
}

export interface ResolvedIconList {
    codename: string;
    iconList: [ResolvedIcon, ResolvedIcon, ResolvedIcon];
    type: ContentTypeCodenames.SectionIconList;
}

const iconListResolver = (data: SectionIconList): ResolvedIconList => {
    const { icon1, label1, icon2, label2, icon3, label3 } = data.elements;

    return {
        codename: data.system.codename,
        iconList: [
            {
                icon: iconNameMap[icon1.value[0].codename as keyof typeof iconNameMap],
                label: label1.value,
            },
            {
                icon: iconNameMap[icon2.value[0].codename as keyof typeof iconNameMap],
                label: label2.value,
            },
            {
                icon: iconNameMap[icon3.value[0].codename as keyof typeof iconNameMap],
                label: label3.value,
            },
        ],
        type: ContentTypeCodenames.SectionIconList,
    };
};

export default iconListResolver;
